
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';

import { AzureCosmosDBLinkedService } from 'app/model/linkedservice/azure-cosmos-db.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'DocumentDbCollection',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.CosmosDb_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.CosmosDb_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureCosmosDBLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureCosmosDbDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = false;
    }
}
